<template>
  <v-container fluid >
    <v-row no-gutters class="pa-0">
      <v-col cols="12" sm="12" md="12" xs="12" lg="12" xl="12">
        <SalarieTaxFreeCRUD />
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
import SalarieTaxFreeCRUD from './SalarieTaxFreeCRUD'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'

export default {
  name: 'salarietaxfree',
  data () {
    return {
      msg: '',
      lang: {},
      langC: {},
      locMonths: [],
      locYears: [],
      saving: false,
      postNew: false,
      mainQuery2: ''
    }
  },
  mounted () {
    if (this.$store.state.language === 'EN') {
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.langC = commHr
    }
  },
  methods: {
 

  },
  computed: {

  },
  watch: {

  },
  components: {
    SalarieTaxFreeCRUD
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
